import * as React from 'react'

const SuccessTickIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    fill="none"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.998 57.6c14.139 0 25.6-11.462 25.6-25.6 0-14.139-11.461-25.6-25.6-25.6-14.138 0-25.6 11.461-25.6 25.6 0 14.139 11.462 25.6 25.6 25.6Zm11.863-29.737a3.2 3.2 0 1 0-4.525-4.526L28.798 33.874l-4.137-4.137a3.2 3.2 0 0 0-4.525 4.526l6.4 6.4a3.2 3.2 0 0 0 4.525 0l12.8-12.8Z"
      fill={props.fill}
    />
  </svg>
)

SuccessTickIcon.defaultProps = {
  height: 64,
  width: 64,
  fill: '#16A34A'
}

export { SuccessTickIcon }
